import request from '@/utils/request';

/**
 * 获取客户列表
 * @param { page, count, customerName, customerTel, parentName } data
 */
export function getCustomerList(data) {
  return request({
    url: '/customer/list',
    method: 'post',
    data
  });
}
/**
 * 获取客户标签列表
 */
export function getCustomerTag(data) {
  return request({
    url: '/customer-lable/list',
    method: 'post',
    data
  });
}

export function getfollowupstatusall(data) {
  return request({
    url: '/customer/follow-up-status-all',
    method: 'post',
    data
  })
}

/**
 * 获取客户详情
 * @param {id: 客户id} data
 * @returns
 */
export function getCustomerInfo(data) {
  return request({
    url: '/customer/detail',
    method: 'post',
    data
  });
}

/**
 * 附近客户列表
 */
export function getNearList(data) {
  return request({
    url: '/customer/near-list',
    method: 'post',
    data
  })
}

/**
 * 新建客户
 */
export function createCustomer(data) {
  return request({
    url: '/customer/create',
    method: 'post',
    data
  })
}

/**
 * 修改客户信息
 */
export function updateCustomer(data) {
  return request({
    url: '/customer/update',
    method: 'post',
    data
  });
}

/**
 * 修改客户信息
 */
export function getnoticenum(data) {
  return request({
    url: '/customer-follow-up-notice/notice-num',
    method: 'post',
    data
  });
}

/**
 * 批量修改客户信息
 */
export function batchUpdateCustomer(data) {
  return request({
    url: '/customer/batch-update',
    method: 'post',
    data
  });
}

/**
 * 公海列表
 */
export function customerPoolList(data) {
  return request({
    url: '/customer-pool/list',
    method: 'post',
    data
  })
}

/**
 * 修改公海
 */
export function modifyCustomerPool(data) {
  return request({
    url: 'customer-pool/update',
    method: 'post',
    data
  })
}

/**客户对应组织结构 */

// 创建客户机构
export function createCustomerRegion(data) {
  return request({
    url: '/customer-org/create',
    method: 'post',
    data
  })
}

// 修改客户机构
export function updateCustomerRegion(data) {
  return request({
    url: '/customer-org/update',
    method: 'post',
    data
  })
}

// 获取客户机构列表
export function getCustomerRegionList(data) {
  return request({
    url: '/customer-org/list',
    method: 'post',
    data
  })
}

// 获取客户信息采集详情
export function getCustomerCollectDetail(data) {
  return request({
    url: '/customer-info-collect/detail',
    method: 'post',
    data
  })
}
// 客户信息采集新增
export function getCustomerCollectCreate(data) {
  return request({
    url: '/customer-info-collect/create',
    method: 'post',
	// headers: { 'content-type': 'application/x-www-form-urlencoded' },
    data
  })
}

// 客户信息采集标签列表
export function getCustomerCollectLable(data) {
  return request({
    url: '/customer-info-collect/lable-list',
    method: 'post',
	headers: { 'content-type': 'application/x-www-form-urlencoded;charset=UTF-8' },
    data
  })
}
//提交客户意向
export function updateCustomerIntention(data) {
  return request({
    url: '/customer/update-customer-intention',
    method: 'post',
    data
  })
}
//已学课程
export function getLearnedCourseList(data) {
  return request({
    url: '/customer-course/course-list',
    method: 'post',
    data
  })
}

// 客户信息采集验证接口
export function Acquisitionverification(data) {
  return request({
    url: '/customer-info-collect/verify-captcha',
    method: 'post',
    data
  })
}

// 客户意向标签勾选
export function customerToLableSet(data) {
  return request({
    url: '/customer-to-lable/set',
    method: 'post',
    data
  })
}


